export var PackageType;
(function (PackageType) {
    PackageType[PackageType["Float"] = 0] = "Float";
    PackageType[PackageType["FloatArray"] = 1] = "FloatArray";
    PackageType[PackageType["Integer"] = 2] = "Integer";
    PackageType[PackageType["IntegerArray"] = 3] = "IntegerArray";
    PackageType[PackageType["ByteArray"] = 4] = "ByteArray";
})(PackageType || (PackageType = {}));
